import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-17e56653")

_pushScopeId("data-v-17e56653")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = { class: "mar-r-8" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "状态", -1)
const _hoisted_5 = { class: "mar-r-8" }
const _hoisted_6 = {
  key: 0,
  class: "flex button-group flexC"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "付款", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "标记已付款", -1)
const _hoisted_9 = {
  key: 1,
  class: "flex button-group flexC"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "标记待付款", -1)
const _hoisted_11 = { class: "flex flexR mar-t-22" }
const _hoisted_12 = { style: {"width":"280px"} }
const _hoisted_13 = { style: {"width":"280px"} }
const _hoisted_14 = { style: {"width":"280px"} }
const _hoisted_15 = { class: "flex flexC" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_select, {
          style: {"width":"108px"},
          placeholder: "请选择",
          modelValue: _ctx.screenParameter.status,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParameter.status = $event)),
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenChange($event, 'status'))),
          clearable: ""
        }, {
          default: _withId(() => [
            _createVNode(_component_el_option, {
              label: "待付款",
              value: 0
            }),
            _createVNode(_component_el_option, {
              label: "已付款",
              value: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_select, {
          modelValue: _ctx.screenParameter.type,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenParameter.type = $event)),
          placeholder: "请选择",
          clearable: "",
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectChange($event, 'status'))),
          class: "mar-r-8",
          style: {"width":"114px"}
        }, {
          default: _withId(() => [
            _createVNode(_component_el_option, {
              label: "开单时间",
              value: "1"
            }),
            _createVNode(_component_el_option, {
              label: "结算时间",
              value: "2"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.screenParameter.time,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.screenParameter.time = $event)),
          type: "daterange",
          align: "right",
          "unlink-panels": "",
          "range-separator": "-",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          shortcuts: _ctx.shortcuts,
          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.screenChange($event, 'time')))
        }, null, 8, ["modelValue", "shortcuts"])
      ]),
      _createVNode(_component_el_input, {
        style: {"width":"202px"},
        modelValue: _ctx.screenParameter.search,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.screenParameter.search = $event)),
        placeholder: "搜索",
        clearable: "",
        "suffix-icon": "el-icon-search",
        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectChange($event,'search')))
      }, null, 8, ["modelValue"])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "200"
        }, {
          default: _withId((scope) => [
            (scope.row.is_return_advance==0)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  (_ctx.roleList.pay)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: ($event: any) => (_ctx._implementPurchaseCope(scope.row.id, scope.$index))
                      }, {
                        default: _withId(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.roleList.flag_pay)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        onClick: ($event: any) => (_ctx._upstatus(scope.row.id))
                      }, {
                        default: _withId(() => [
                          _hoisted_8
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_9, [
                  (_ctx.roleList.flag_pay)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: ($event: any) => (_ctx._upstatus(scope.row.id))
                      }, {
                        default: _withId(() => [
                          _hoisted_10
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "付款",
      modelValue: _ctx.dialog_show,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dialog_show = $event)),
      "model-value": _ctx.dialog_model,
      center: "",
      width: 1000,
      "before-close": ()=>{_ctx.dialog_model = false}
    }, {
      footer: _withId(() => [
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_el_button, {
            class: "bg-red mar-r-16",
            onClick: _ctx._form_submit
          }, {
            default: _withId(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.dialog_model = false))
          }, {
            default: _withId(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _withDirectives(_createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.form,
          rules: _ctx.form_rules,
          "label-width": "120px",
          style: {"width":"850px","margin":"0 auto"},
          inline: true
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, { label: "工单号" }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.form.ordersn), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "车牌号码" }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.form.order_crd_code_text), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "待付款金额" }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_14, _toDisplayString(_ctx.form.advance_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "付款日期",
              prop: "pay_time"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.form.pay_time,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.pay_time = $event)),
                  type: "date",
                  style: {"width":"280px"},
                  placeholder: "选择日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "付款方式",
              prop: "pay_type"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择",
                  modelValue: _ctx.form.pay_type,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.pay_type = $event)),
                  clearable: "",
                  class: "mar-r-8",
                  style: {"width":"280px"}
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.zf, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.basicset_name,
                        value: item.basicset_id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "经手人",
              prop: "admin_id"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择",
                  modelValue: _ctx.form.admin_id,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.admin_id = $event)),
                  clearable: "",
                  class: "mar-r-8",
                  style: {"width":"280px"}
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.staff, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.nickname,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"400px"},
                  modelValue: _ctx.form.desc,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.desc = $event)),
                  type: "textarea",
                  row: "3",
                  placeholder: "请输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]), [
          [_directive_loading, _ctx.dialog_load]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "model-value", "before-close"])
  ]))
})